<div class="leave-application-add" fxLayout="column" fxLayoutGap="15px"  >
<!--  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">-->
<!--    <button (click)="save()" [class.spinner]="processingRequest"-->
<!--            [disabled]="!leaveApplicationFormValid"-->
<!--            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>-->
<!--    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>-->
<!--  </div>-->

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>

        <div fxLayout="row" *ngIf="(userPermissions | async).human_resources.admin_root">
          <app-dict
            fxFlex="100" dictType="leave_application_type" label="Rodzaj wniosku"
            [required]="true" [control]="typeControl" ></app-dict>
        </div>

        <div fxLayout="row" *ngIf="!(userPermissions | async).human_resources.admin_root">
          <app-dict
            fxFlex="100" dictType="leave_application_type" label="Rodzaj wniosku "
            [required]="true" [control]="typeControl"  [onlyKeys]="LEAVE_TYPES" ></app-dict>
        </div>

        <div fxLayout="row" fxLayoutGap="15px"  *ngIf="reception">
          <app-datepicker
            fxFlex="50"
            label="Data od"
            placeholder="2000-01-01 00:00"
            [required]="true"
            [control]="startControl"
            [minDate]="'2026-08-01'"
            [maxDate]="'2026-08-31'"
          ></app-datepicker>

          <app-datepicker
            fxFlex="50"
            label="Data do"
            placeholder="2000-01-01 00:00"
            [required]="true"
            [control]="endControl"
            [minDate]="'2026-08-01'"
            [maxDate]="'2026-08-31'"
          ></app-datepicker>
        </div>
        <div fxLayout="row" fxLayoutGap="15px"  *ngIf="!reception">
          <app-datepicker
            fxFlex="50"
            label="Data od"
            placeholder="2000-01-01 00:00"
            [required]="true"
            [control]="startControl"
            [maxDate]="half ? null : endControl.value"
          ></app-datepicker>

          <app-datepicker
            fxFlex="50"
            label="Data do"
            placeholder="2000-01-01 00:00"
            [required]="true"
            [control]="endControl"
            [minDate]="startControl.value"
          ></app-datepicker>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" >
          <mat-form-field class="dict-form-field" fxFlex="100">
            <mat-label>Wymiar urlopu</mat-label>
            <mat-select [required]="true" (selectionChange)="onSelectionChange($event.value)" [formControl]="leaveTypeControl">
              <mat-option value="full">Pełny dzień</mat-option>
              <mat-option value="half"  >1/2 dnia</mat-option>
              <mat-option value="hour" *ngIf="recreational" >Godzina</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div fxLayout="row"  *ngIf="half  && !hour">
          <app-dict
            fxFlex="100" dictType="leave_application_time" label="Część dnia" [onlyKeys]="LEAVE_TIME"
            [required]="true" [control]="timeControl" ></app-dict>
        </div>

        <div fxLayout="row"  *ngIf="half  && hour">
          <app-dict
            fxFlex="100" dictType="leave_application_time" label="Część dnia"  [skipKeys]="LEAVE_TIME"
            [required]="true" [control]="timeControl" ></app-dict>
        </div>

        <div fxLayout="row"  *ngIf="hour">
          <mat-form-field class="dict-form-field" fxFlex="100">
            <mat-label>Wymiar godzin</mat-label>
            <mat-select
              [required]="true"
              [formControl]="hourDimensionsControl">

              <mat-option *ngFor="let opt of hourDimensions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>

            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="24px" *ngIf="half" style="padding-bottom: 15px;">

          <!-- Godzina rozpoczęcia -->
          <div fxLayout="column" fxLayoutGap="6px"  fxFlex="50" >
            <label class="time-label">Godzina rozpoczęcia</label>
            <ngx-timepicker-field
              [format]="24"
              [defaultTime]="'12:00'"
              [formControl]="startsAtTimeControl">
            </ngx-timepicker-field>
          </div>

          <!-- Godzina zakończenia -->
          <div fxLayout="column" fxLayoutGap="6px" fxFlex="50" >
            <label class="time-label">Godzina zakończenia</label>
            <ngx-timepicker-field
              [format]="24"
              [defaultTime]="'12:00'"
              [formControl]="endAtTimeControl">
            </ngx-timepicker-field>
          </div>

        </div>

        <div fxLayout="row"  *ngIf="!half">
          <mat-form-field class="partners-add-input" fxFlex="100" >
            <mat-label>Liczba dni</mat-label>
            <input matInput
                   placeholder="Liczba dni"
                   name=""
                   type="number"
                   [min]="1"
                   [step]="1"
                   [required]="!half"
                   [formControl]="dayControl"
            >
          </mat-form-field>
        </div>

        <div fxLayout="row" style="padding-top: 15px;">
          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Uwagi</mat-label>
              <input [required]="noteValid" matInput placeholder="Uwagi" [formControl]="noteControl" >
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" *ngIf="noteValid">
          <h4> Aby skorzystać z urlopu okolicznościowego, załącz dokument potwierdzający prawo do jego udzielenia.
            Jeśli nie dodasz dokumentu teraz, masz 7 dni od daty zakończenia urlopu na jego uzupełnienie.
            Brak dokumentu w tym terminie spowoduje, że urlop zostanie rozliczony jako urlop wypoczynkowy.</h4>
        </div>

        <div fxLayout="row" *ngIf="noteValid">

          <app-file-drag-and-drop
            fxFlex="100"
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="*/*"
          ></app-file-drag-and-drop>
        </div>



      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!leaveApplicationFormValid "
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
